<template>
    <div class="card" style="min-width: 200px;min-height:100px">
        <h5 class="card-header">
            {{student.name}}
        </h5>
        <div class="card-body">
            <label>班主任：<span v-for="(employee,index) in student.employee" :key="index">{{employee}} </span></label>
            <br/>
            <label>年级：{{student.grade}}</label>
            <br/>
            <label>在读学科：<span v-for="(subject,index) in student.subjects" :key="index">{{subject}}&nbsp;</span></label>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StudentDetail",
        data() {
            return {}
        },
        created() {
        },
        props: {
            student: '',
        },
        computed: {},
        methods: {}
    }
</script>

<style scoped>

</style>